"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorListDataFromJSON = AuthorListDataFromJSON;
exports.AuthorListDataFromJSONTyped = AuthorListDataFromJSONTyped;
exports.AuthorListDataToJSON = AuthorListDataToJSON;
exports.AuthorListDataToJSONTyped = AuthorListDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AuthorListDataFromJSON(json) {
    return AuthorListDataFromJSONTyped(json, false);
}
function AuthorListDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'payload': !(0, runtime_1.exists)(json, 'payload') ? undefined : (0, _1.AuthorListDataPayloadFromJSON)(json['payload']),
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(_1.AuthorFromJSON)),
    };
}
function AuthorListDataToJSON(value) {
    return AuthorListDataToJSONTyped(value, false);
}
function AuthorListDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'payload': (0, _1.AuthorListDataPayloadToJSON)(value.payload),
        'totalCount': value.totalCount,
        'items': value.items === undefined ? undefined : (value.items.map(_1.AuthorToJSON)),
    };
}
